export default __webpack_public_path__ + "static/media/22.61da3417.png";